// extracted by mini-css-extract-plugin
module.exports = {"content":"FeaturedAuction_content__1juf4"};